import React, { useState } from 'react';
import { View, ScrollView, StyleSheet, TouchableOpacity, Alert, Modal } from 'react-native';
import { Text, Card, Avatar, useTheme, Divider, List, Button } from 'react-native-paper';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import { useAuth } from '../../../context/AuthContext';

const AdminProfileScreen = ({ navigation }) => {
  const theme = useTheme();
  const { user, signOut } = useAuth();
  const [logoutDialogVisible, setLogoutDialogVisible] = useState(false);

  const handleLogout = () => {
    signOut();
    // AuthContext'teki signOut işlemi routing'i zaten hallediyor olmalı
  };

  const confirmLogout = () => {
    setLogoutDialogVisible(true);
  };

  // İlk harfi büyük yapma yardımcı işlevi
  const getInitials = (name) => {
    if (!name) return '?';
    return name.charAt(0).toUpperCase();
  };

  // Tarih formatı
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      const date = new Date(dateString);
      const padZero = (num) => num.toString().padStart(2, '0');
      
      return `${padZero(date.getDate())}.${padZero(date.getMonth() + 1)}.${date.getFullYear()} ${padZero(date.getHours())}:${padZero(date.getMinutes())}`;
    } catch (error) {
      return dateString;
    }
  };

  return (
    <ScrollView style={styles.container}>
      <Card style={styles.profileCard}>
        <View style={styles.profileHeader}>
          <Avatar.Text 
            size={80} 
            label={getInitials(user?.name || user?.username)} 
            style={{ backgroundColor: 'rgb(125, 76, 236)' }}
            color="white"
          />
          <View style={styles.profileInfo}>
            <Text style={styles.userName}>{user?.name || '-'}</Text>
            <Text style={styles.userEmail}>{user?.email || '-'}</Text>
            <Text style={styles.userRole}>Yönetici</Text>
          </View>
        </View>
        
        <Button 
          mode="contained" 
          icon="account-edit"
          onPress={() => navigation.navigate('EditProfile')}
          style={[styles.editButton, {backgroundColor: 'rgb(125, 76, 236)'}]}
          labelStyle={{color: 'white'}}
        >
          <Text style={{color: 'white'}}>Profili Düzenle</Text>
        </Button>
      </Card>
      
      <Card style={styles.menuCard}>
        <List.Item
          title="Profil Bilgilerim"
          description="Kişisel bilgilerinizi düzenleyin"
          left={props => <List.Icon {...props} icon="account-circle" />}
          right={props => <List.Icon {...props} icon="chevron-right" />}
          onPress={() => navigation.navigate('EditProfile')}
          style={styles.menuItem}
        />
        
        <Divider />
        
        <List.Item
          title="Şifre Değiştir"
          description="Giriş şifrenizi değiştirin"
          left={props => <List.Icon {...props} icon="lock" />}
          right={props => <List.Icon {...props} icon="chevron-right" />}
          onPress={() => navigation.navigate('ChangePassword')}
          style={styles.menuItem}
        />
        
        <Divider />
        
        <List.Item
          title="Oyun Parkı Ayarları"
          description="Oyun parkı fiyatlandırma ayarlarını düzenleyin"
          left={props => <List.Icon {...props} icon="cash-register" />}
          right={props => <List.Icon {...props} icon="chevron-right" />}
          onPress={() => navigation.navigate('ParkSettings')}
          style={styles.menuItem}
        />
        
        {/*<List.Item
          title="Bildirim Ayarları"
          description="Bildirim tercihlerinizi yönetin"
          left={props => <List.Icon {...props} icon="bell" />}
          right={props => <List.Icon {...props} icon="chevron-right" />}
          onPress={() => navigation.navigate('NotificationSettings')}
          style={styles.menuItem}
        />*/}
      </Card>
    
      
      <Card style={styles.infoCard}>
        
        
        <Divider />
        
        <List.Item
          title="Kullanıcı Adı"
          description={user?.username || 'Bilgi yok'}
          left={props => <List.Icon {...props} icon="account" color="rgb(125, 76, 236)" />}
        />
        
        <Divider />
        
        
      </Card>
      
      <Button 
        mode="outlined" 
        icon="logout"
        onPress={confirmLogout}
        style={[styles.logoutButton, {backgroundColor: 'rgb(125, 76, 236)'}]}
        textColor="rgb(255, 255, 255)"
        color='white'
      >
        Çıkış Yap
      </Button>
      
      <View style={styles.versionContainer}>
        <Text style={styles.versionText}>Uygulama Sürümü: 1.0.0</Text>
      </View>
      
      <Modal
        visible={logoutDialogVisible}
        transparent={true}
        onRequestClose={() => setLogoutDialogVisible(false)}
      >
        <View style={styles.modalContainer}>
          <View style={styles.modalContent}>
            <MaterialCommunityIcons 
              name="logout" 
              size={50} 
              color="rgb(125, 76, 236)"
              style={[styles.modalIcon, {backgroundColor: 'rgba(125, 76, 236, 0.1)', borderRadius: 50, padding: 10}]} 
            />
            
            <Text style={styles.modalTitle}>Çıkış Yap</Text>
            <Text style={styles.modalText}>Uygulamadan çıkış yapmak istediğinizden emin misiniz?</Text>
            
            <View style={styles.modalButtonContainer}>
              <Button 
                mode="contained" 
                onPress={handleLogout}
                style={[styles.modalButton, { backgroundColor: 'rgb(125, 76, 236)' }]}
                icon="logout"
                textColor="white"
              >
                Çıkış Yap
              </Button>
              <Button 
                mode="outlined" 
                onPress={() => setLogoutDialogVisible(false)}
                style={[styles.modalButton, {borderColor: 'rgb(125, 76, 236)'}]}
                textColor="rgb(125, 76, 236)"
              >
                İptal
              </Button>
            </View>
          </View>
        </View>
      </Modal>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'rgb(232, 162, 249)',
  },
  modalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  modalContent: {
    width: '80%',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderRadius: 10,
    padding: 20,
    alignItems: 'center',
    elevation: 5,
    borderWidth: 1,
    borderColor: 'rgb(125, 76, 236)',
  },
  modalIcon: {
    marginBottom: 15,
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 10,
    color: 'rgb(125, 76, 236)',
  },
  modalText: {
    fontSize: 16,
    textAlign: 'center',
    marginBottom: 20,
  },
  modalButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
  },
  modalButton: {
    marginHorizontal: 5,
    minWidth: 120,
  },
  profileCard: {
    margin: 12,
    padding: 16,
    elevation: 4,
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
  },
  profileHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
  },
  profileInfo: {
    marginLeft: 16,
  },
  userName: {
    fontSize: 20,
    fontWeight: 'bold',
    color: 'rgb(125, 76, 236)',
  },
  userEmail: {
    fontSize: 14,
    color: '#757575',
    marginTop: 2,
  },
  userRole: {
    fontSize: 14,
    color: 'rgb(125, 76, 236)',
    marginTop: 6,
    fontWeight: '500',
  },
  editButton: {
    marginTop: 8,
  },
  menuCard: {
    margin: 12,
    marginTop: 0,
    elevation: 2,
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
  },
  menuItem: {
    padding: 4,
  },
  infoCard: {
    margin: 12,
    marginTop: 0,
    elevation: 2,
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
  },
  logoutButton: {
    margin: 12,
    marginTop: 24,
    borderColor: 'rgb(125, 76, 236)',
  },
  versionContainer: {
    alignItems: 'center',
    marginTop: 24,
    marginBottom: 36,
  },
  versionText: {
    color: '#9E9E9E',
    fontSize: 14,
  },
});

export default AdminProfileScreen;
